// import { FASTFIELD_RECALL_URL } from './../constants';
// import axios from 'axios';

// import { BASE_API_URL, FASTFIELD_DISPATCH_URL, StorageKey } from '../constants';
// import { readValue } from '../utils/local-storage.util';

// export interface QueryKeyConfig {
//   queryKey: any[];
//   route: string;
//   params?: any;
//   isEnabled?: boolean;
//   retry?: number;
// }

// export interface MutationKeyConfig {
//   mutationKey: any | any[];
//   route: string;
//   action: 'POST' | 'PUT' | 'DELETE';
//   disableSnackbar?: boolean;
// }

// const getAuthorizationHeader = () => {
//   const token = readValue(StorageKey.AUTH_TOKEN);
//   return {
//     Authorization: `Bearer ${token}`,
//   };
// };

// export const getData = async <T>(route: string, params: any, options?: { cancelToken: any }): Promise<T> => {
//   try {
//     const result = await axios.get<T>(`${BASE_API_URL}${route}`, {
//       params,
//       headers: {
//         ...getAuthorizationHeader(),
//       },
//       cancelToken: options?.cancelToken,
//     });

//     return result.data;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       if (error.response?.status === 401) {
//         localStorage.clear();
//         window.location.href = '/';
//       } else {
//         // Handle other errors
//         console.error('Error:', error.response?.status, error.message);
//       }
//     } else {
//       console.error('Unexpected error', error);
//     }
//     throw error; // Re-throw the error after logging it
//   }
// };

// export const postData = async <T>(route: string, data: any) => {
//   const fullRoute = `${BASE_API_URL}${route}`;
//   try {
//     const result = await axios.post<T>(fullRoute, data, {
//       headers: {
//         ...getAuthorizationHeader(),
//       },
//     });
//     return result.data;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       if (error.response?.status === 401) {
//         localStorage.clear();
//         window.location.href = '/';
//       } else {
//         // Handle other errors
//         console.error('Error:', error.response?.status, error.message);
//       }
//     } else {
//       console.error('Unexpected error', error);
//     }
//     throw error; // Re-throw the error after logging it
//   }
// };

// export const putData = async <T>(route: string, data: any) => {
//   const fullRoute = `${BASE_API_URL}${route}`;
//   try {
//     const result = await axios.put<T>(fullRoute, data, {
//       headers: {
//         ...getAuthorizationHeader(),
//       },
//     });
//     return result.data;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       if (error.response?.status === 401) {
//         localStorage.clear();
//         window.location.href = '/';
//       } else {
//         // Handle other errors
//         console.error('Error:', error.response?.status, error.message);
//       }
//     } else {
//       console.error('Unexpected error', error);
//     }
//     throw error; // Re-throw the error after logging it
//   }
// };

// export const deleteData = async <T>(route: string) => {
//   const result = await axios.delete<T>(`${BASE_API_URL}${route}`, {
//     headers: {
//       ...getAuthorizationHeader(),
//     },
//   });
//   return result.data;
// };

// export const uploadData = async <T>(route: string, data: any) => {
//   const fullRoute = `${BASE_API_URL}${route}`;
//   const result = await axios.post<T>(fullRoute, data, {
//     headers: {
//       ...getAuthorizationHeader(),
//       'Content-Type': 'multipart/form-data',
//     },
//   });
//   return result.data;
// };

// // Api call for Fast field
// export const postDataFastField = async <T>(route: string, data: any) => {
//   const fullRoute = `${FASTFIELD_DISPATCH_URL}${route}`;
//   const result = await axios.post<T>(fullRoute, data, {
//     headers: {
//       ...getAuthorizationHeader(),
//     },
//   });
//   return result.data;
// };

// export const postDataFastFieldRecall = async <T>(route: string, data: any) => {
//   const fullRoute = `${FASTFIELD_RECALL_URL}${route}`;
//   const result = await axios.post<T>(fullRoute, data, {
//     headers: {
//       ...getAuthorizationHeader(),
//     },
//   });
//   return result.data;
// };

// ----------------------------Refresh Token--------------------------------------

import { FASTFIELD_RECALL_URL, QUICK_BOOK_URL } from './../constants';
import axios, { AxiosError } from 'axios';

import { BASE_API_URL, FASTFIELD_DISPATCH_URL, StorageKey } from '../constants';
import { readValue, saveValue } from '../utils/local-storage.util';

export interface QueryKeyConfig {
  queryKey: any[];
  route: string;
  params?: any;
  isEnabled?: boolean;
  retry?: number;
}

export interface MutationKeyConfig {
  mutationKey: any | any[];
  route: string;
  action: 'POST' | 'PUT' | 'DELETE';
  disableSnackbar?: boolean;
  disableFailSnackbar?: boolean;
}

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

const getAuthorizationHeader = () => {
  const token = readValue(StorageKey.AUTH_TOKEN);
  return {
    Authorization: `Bearer ${token}`,
  };
};

const onRefreshed = (token: string) => {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
};

const addRefreshSubscriber = (callback: (token: string) => void) => {
  refreshSubscribers.push(callback);
};

const refreshToken = async () => {
  const token = readValue(StorageKey.AUTH_TOKEN);
  const refreshToken = readValue(StorageKey.REFRESH_TOKEN);

  try {
    const response = await axios.post(`${BASE_API_URL}/Connect/refreshtoken`, {
      token,
      refreshToken,
    });

    const newToken = response.data.data.accessToken;
    const newRefreshToken = response?.data?.data?.refreshToken;
    saveValue(StorageKey.AUTH_TOKEN, newToken);
    saveValue(StorageKey.REFRESH_TOKEN, newRefreshToken);
    onRefreshed(newToken);
    return newToken;
  } catch (error) {
    console.error('Unable to refresh token:', error);
    localStorage.clear();
    window.location.href = '/';
    throw error;
  } finally {
    isRefreshing = false;
  }
};

const handleRequest = async <T>(request: () => Promise<T>) => {
  try {
    return await request();
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        return refreshToken()
          .then(() => request())
          .catch((refreshError) => {
            console.error('Error refreshing token:', refreshError);
            throw refreshError;
          });
      }

      return new Promise<T>((resolve, reject) => {
        addRefreshSubscriber(async (token) => {
          try {
            resolve(await request());
          } catch (err) {
            reject(err);
          }
        });
      });
    } else {
      console.error('Unexpected error', error);
      throw error;
    }
  }
};

export const getData = async <T>(route: string, params: any, options?: { cancelToken: any }): Promise<T> => {
  return handleRequest(async () => {
    const result = await axios.get<T>(`${BASE_API_URL}${route}`, {
      params,
      headers: {
        ...getAuthorizationHeader(),
      },
      cancelToken: options?.cancelToken,
    });
    return result.data;
  });
};

export const postData = async <T>(route: string, data: any, options?: { cancelToken: any }) => {
  return handleRequest(async () => {
    const result = await axios.post<T>(`${BASE_API_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
      },
      cancelToken: options?.cancelToken,
    });
    return result.data;
  });
};

export const putData = async <T>(route: string, data: any) => {
  return handleRequest(async () => {
    const result = await axios.put<T>(`${BASE_API_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
      },
    });
    return result.data;
  });
};

export const deleteData = async <T>(route: string) => {
  return handleRequest(async () => {
    const result = await axios.delete<T>(`${BASE_API_URL}${route}`, {
      headers: {
        ...getAuthorizationHeader(),
      },
    });
    return result.data;
  });
};

export const uploadData = async <T>(route: string, data: any) => {
  return handleRequest(async () => {
    const result = await axios.post<T>(`${BASE_API_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return result.data;
  });
};

// Api call for Fast field
export const postDataFastField = async <T>(route: string, data: any) => {
  return handleRequest(async () => {
    const result = await axios.post<T>(`${FASTFIELD_DISPATCH_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
      },
    });
    return result.data;
  });
};

export const postDataFastFieldRecall = async <T>(route: string, data: any) => {
  return handleRequest(async () => {
    const result = await axios.post<T>(`${FASTFIELD_RECALL_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
      },
    });
    return result.data;
  });
};

export const postDataForDux = async <T>(route: string, data: any) => {
  // return handleRequest(async () => {
  const result = await axios.post<T>(`${route}`, data, {
    headers: {
      ...getAuthorizationHeader(),
      apikey: 'D5DD32E0-9516-4078-99D3-B09E95D82422', // Adding apikey from Postman
      Authorization: 'Basic ZHV4OkszeSR0MG4zIWFwaQ==', // Adding Authorization header from Postman
    },
  });
  return result.data;
  // });
};

export const postDataForQuickBook = async <T>(route: string, data: any) => {
  return handleRequest(async () => {
    const result = await axios.post<T>(`${QUICK_BOOK_URL}${route}`, data, {
      headers: {
        ...getAuthorizationHeader(),
      },
    });
    return result.data;
  });
};
